/** Reset window scroll — used when entering a list page after a long form. */
export function resetPageScroll(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
